<template>
  <v-container fluid>
    <v-layout wrap>
      <v-flex xs12>count: {{ items.length }}</v-flex>
      <template v-for="item in items">
        <v-flex :key="item.id" xs12 mb-2>
          <debug-item :item="item"></debug-item>
        </v-flex>
      </template>
    </v-layout>
  </v-container>
</template>
<script>
  import { mapState } from 'vuex';
  import DebugItem from './Item.vue';

  export default {
    name: 'DebugIndex',
    components: { DebugItem },
    computed: mapState({
      items: s => s.logger.items
    })
  };
</script>
